
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic-board/page/[num]",
      function () {
        return require("private-next-pages/topic-board/page/[num].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic-board/page/[num]"])
      });
    }
  